import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export const MONTHS_FR = [
  "", "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre",
];

export const TECH_FUNCTIONS = [
  "Régisseur/se Général(e)", "Attaché(e) de Production", "Cariste",
  "Technicien(ne) Spécialisé(e)", "Technicien(ne) de Plateau",
];
export const OUVREUSE_FUNCTIONS = ["Chef(fe) Ouvreur/se", "Ouvreur/se", "Contrôle Bip Bip", "Consigne", "Guichet"];
export const SPECIFICATIONS = [
  "Chef(fe) d'équipe", "Permanent", "Son", "Lights", "Vidéo", "Poursuiteur/se", "Habilleuse", "Scaff",
];
export const VACATIONS = [
  "1ère vacation", "2ème Vacation", "3ème Vacation", "4ème Vacation", "5ème Vacation",
  "6ème Vacation", "Rechargeurs", "Matin", "Soir", "All Day", "Show",
];
export const COMPLEMENTS = [
  "Pas de complément", "Equipe de 1 à 49 personnes", "Equipe supérieure ou égale à 50 personnes", "Pré courses",
];
export const COMPLEMENT_FUNCTIONS = [
  "Equipe de 1 à 49 personnes", "Equipe supérieure ou égale à 50 personnes", "Pré courses",
];
export const CATERING_FUNCTIONS = ["Aide Catering"];
export const HOUR_BRACKETS = [4, 6, 8, 10, 12];
export const ALL_FUNCTIONS = [...TECH_FUNCTIONS, ...OUVREUSE_FUNCTIONS, ...COMPLEMENT_FUNCTIONS, ...CATERING_FUNCTIONS];

// Tri canonique des équipes, indépendant de l'ordre d'ajout.
const _n = (s) => (s || "").trim().toLowerCase();
const _techGroup = (m) => {
  const f = _n(m.fonction), s = _n(m.specifications);
  if (f === _n("Régisseur/se Général(e)")) return 0;
  if (f === _n("Attaché(e) de Production")) return 1;
  if (f === _n("Technicien(ne) Spécialisé(e)") && s === _n("Chef(fe) d'équipe")) return 2;
  if (f === _n("Cariste")) return 3;
  if (f === _n("Technicien(ne) Spécialisé(e)")) return 4;
  if (f === _n("Technicien(ne) de Plateau")) return 5;
  return 6;
};
const _ouvGroup = (m) => {
  const i = OUVREUSE_FUNCTIONS.findIndex((o) => _n(o) === _n(m.fonction));
  return i < 0 ? OUVREUSE_FUNCTIONS.length : i;
};
const _vacIndex = (m) => {
  const i = VACATIONS.findIndex((v) => _n(v) === _n(m.vacation));
  return i < 0 ? VACATIONS.length : i;
};
export function sortCrewMembers(list) {
  const rank = (m) => (m.category === "catering" ? 2 : m.category === "ouvreur" ? 1 : 0);
  return [...(list || [])].sort((a, b) => {
    const d0 = rank(a) - rank(b);
    if (d0) return d0;
    const r = rank(a);
    if (r === 1) {
      const d = _ouvGroup(a) - _ouvGroup(b);
      return d || _n(a.nom_prenom).localeCompare(_n(b.nom_prenom));
    }
    if (r === 2) {
      const d = _vacIndex(a) - _vacIndex(b);
      return d || _n(a.nom_prenom).localeCompare(_n(b.nom_prenom));
    }
    let d = _techGroup(a) - _techGroup(b);
    if (d) return d;
    d = _vacIndex(a) - _vacIndex(b);
    return d || _n(a.nom_prenom).localeCompare(_n(b.nom_prenom));
  });
}

// Tri des besoins (liste de personnel) selon la même hiérarchie que les équipes.
export function sortBesoins(list) {
  return [...(list || [])].sort((a, b) => {
    const oa = a.categorie === "Ouvreuses" ? 1 : 0, ob = b.categorie === "Ouvreuses" ? 1 : 0;
    if (oa !== ob) return oa - ob;
    if (oa === 1) return _ouvGroup(a) - _ouvGroup(b);
    const d = _techGroup(a) - _techGroup(b);
    return d || (_vacIndex(a) - _vacIndex(b));
  });
}

export function apiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
